<template>
  <div class="content">
    <div class="md-layout">
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
      >
        <md-card>
          <md-card-header data-background-color="primary">
            <h4 class="title">Contratos Pendentes</h4>
            <p v-if="unsignedContracts.length > 0" class="category">
              Você possui contratos pendentes
            </p>
            <p v-else class="category">Você não possui contratos pendentes</p>
          </md-card-header>
          <md-card-content>
            <md-table
              v-model="contractsModel"
              :table-header-color="tableHeaderColor"
            >
              <md-table-row
                slot="md-table-row"
                slot-scope="{ item }"
                v-if="item.legacy"
              >
                <md-table-cell md-label="Nome">{{ item.name }}</md-table-cell>
                <md-table-cell md-label="Visualizar">
                  <md-button
                    href="#"
                    class="btn-contract"
                    @click="openContract(item.id)"
                    >Ver Contrato</md-button
                  >
                </md-table-cell>
                <md-table-cell md-label="Assinar">
                  <md-button @click="signContract(item.id)" class="btn-contract"
                    >Assinar</md-button
                  >
                </md-table-cell>
              </md-table-row>

              <md-table-row slot="md-table-row" slot-scope="{ item }" v-else>
                <md-table-cell md-label="Nome">{{
                  item.template.name
                }}</md-table-cell>
                <md-table-cell md-label="">
                  <md-button
                    :href="
                      `${gerenariUrl}/api/sign-contract?contract_id=${
                        item.id
                      }&access_token=${userToken()}`
                    "
                    target="_blank"
                    class="btn-contract"
                    >Ver Contrato</md-button
                  >
                </md-table-cell>
                <md-table-cell md-label="Visualizar">
                  <md-button
                    :href="
                      `${gerenariUrl}/api/sign-contract?contract_id=${
                        item.id
                      }&access_token=${userToken()}`
                    "
                    target="_blank"
                    class="btn-contract"
                    >Assinar</md-button
                  >
                </md-table-cell>
              </md-table-row>
            </md-table>
          </md-card-content>
        </md-card>
        <div v-if="contractsModel.length > 1" class="d-flex flex-row-reverse">
          <md-button @click="signContracts()" class="btn-contract">
            Assinar todos contratos
          </md-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Swal from "sweetalert2";
import axios from "axios";
import { sub } from "date-fns";

export default {
  name: "simple-table",
  props: {
    tableHeaderColor: {
      type: String,
      default: "primary"
    }
  },
  computed: {
    unsignedContracts() {
      return this.$store.getters.unsignedContracts;
    },
    userid() {
      return this.$store.getters.user.id;
    },
    gerenariUrl() {
      return "https://app.hubnari.com.br";
    }
  },
  data() {
    return {
      contractsModel: [],
      lastRetryAt: sub(new Date(), { seconds: 30 })
    };
  },
  methods: {
    ...mapActions([
      "logout",
      "fetchContracts",
      "sign",
      "openContract",
      "askContractCode"
    ]),
    userToken() {
      return localStorage.getItem("gerenariAccessToken");
    },
    async signContract(id) {
      const result = await Swal.fire({
        title: "Atenção!",
        text: "Ao prosseguir você concorda com os termos do contrato, assinar?",
        icon: "warning",
        focusConfirm: false,
        reverseButtons: true,
        showCancelButton: true,
        confirmButtonColor: "#9dcf6b",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim",
        cancelButtonText: "Não"
      });
      if (result.isConfirmed) {
        try {
          await Swal.fire({
            title: "Aguarde",
            html: "Carregando...",
            allowOutsideClick: false,
            didOpen: async () => {
              Swal.showLoading();
              await this.sign({ id });

              Swal.hideLoading();
              await Swal.fire("Sucesso!", "Contrato assinado.", "success");

              await this.fetchContracts({ id: this.userid });
              this.contractsModel = this.unsignedContracts;
            }
          });
        } catch (e) {
          Swal.close();
          Swal.fire("Ops!", "Não foi possível completar a ação.", "error");
        }
      }
    },
    async signContracts() {
      const result = await Swal.fire({
        title: "Atenção!",
        text:
          "Ao prosseguir você irá assinar todos os contratos de uma vez, deseja assinar?",
        icon: "warning",
        focusConfirm: false,
        reverseButtons: true,
        showCancelButton: true,
        confirmButtonColor: "#9dcf6b",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim",
        cancelButtonText: "Não"
      });
      if (result.isConfirmed) {
        try {
          await Promise.all(
            this.contractsModel.map(contract =>
              axios.post(
                `https://gerenari-api.hubnari.com.br/central/contracts/${contract.id}/sign`,
                undefined,
                {
                  headers: {
                    Authorization: `Bearer ${this.userToken()}`
                  }
                }
              )
            )
          );
          Swal.fire("Sucesso!", "Contratos assinados.", "success");
          await this.fetchContracts({ id: this.userid });
          this.contractsModel = this.unsignedContracts;
        } catch (e) {
          Swal.close();
          Swal.fire("Ops!", "Não foi possível completar a ação.", "error");
        }
      }
    }
  },
  async mounted() {
    this.contractsModel = this.unsignedContracts;
    await this.fetchContracts({ id: this.userid });
    this.contractsModel = this.unsignedContracts;
  }
};
</script>

<style lang="scss" scoped>
.btn-contract {
  background-color: var(--primary-color) !important;

  &:hover {
    background-color: var(--secondary-color) !important;
  }
}
</style>
